import { useState, useCallback } from 'react';
import ContentCopyOutlinedIcon from '@mui/icons-material/ContentCopyOutlined';
import CheckCircleOutlineIcon from '@mui/icons-material/CheckCircleOutline';

export function useCopyText(text?: string, timeout = 3000) {
  const [isCopied, setIsCopied] = useState(false);

  const copy = useCallback(async () => {
    if (!text) return;
    await navigator.clipboard.writeText(text);
    setIsCopied(true);
    setTimeout(() => setIsCopied(false), timeout);
  }, [text, timeout]);

  const Icon = isCopied ? CheckCircleOutlineIcon : ContentCopyOutlinedIcon;

  return { isCopied, copy, Icon };
}
